export default (editor, opts = {}) => {
  const DOMC = editor.DomComponents;
  const TYPE = DOMC.getType('card');
  const MODEL = TYPE.model;
  const VIEW = TYPE.view;

  DOMC.addType('card', {
    extend: 'card',
    //extendFn: ['init2'], // array of model functions to extend from `parent-type`
    model: {
      init2() {
        this.listenTo(this, 'change:card-img-top', this.cardImageTop);
        this.listenTo(this, 'change:card-header', this.cardHeader);
        this.listenTo(this, 'change:card-img', this.cardImage);
        this.listenTo(this, 'change:card-img-overlay', this.cardImageOverlay);
        this.listenTo(this, 'change:card-body', this.cardBody);
        this.listenTo(this, 'change:card-footer', this.cardFooter);
        this.listenTo(this, 'change:card-img-bottom', this.cardImageBottom);
        this.components().comparator = 'card-order';
        this.set('card-body', true);
      },
    }
  });
}
